import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'

/**
 * Merges class strings, resolving duplicates with the last value winning.
 */
export function cn(...inputs: ClassValue[]): string {
    return clsx(inputs)
}